module.exports = __webpack_public_path__ + "Roboto-Medium.c54f2a3ee42d2a58d82f.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module id = 315
// module chunks = 19